class Filter {
    constructor() {
    }

    static getSearchFilter(name, key, cssCLassName, findByUuid, additionalSearch) {
        let filter = Filter.initFilter(name, key, cssCLassName, 'search', null, findByUuid, additionalSearch);

        filter.clear = function () { Filter.clearFilter(this); };
        filter.clearOption = function () { Filter.clearFilter(this); };
        filter.setOptionByValue = function (optionValue) {
            this.jobUuids.push(optionValue);
            this.search = this.jobUuids.join('||');
            this.filterBy = this.search;
            this.filterByEncode = encodeURIComponent(this.search);
            this.displayFilterBy = [this.search];
        };
        filter.setFilterByOptions = function () { Filter.internalFilterBySet(this); };
        filter.reset = function () { Filter.resetFilter(this); };
        return filter;
    }

    static getTimeFilter(name, key, options, cssCLassName, element) {
        let filter = Filter.initFilter(name, key, cssCLassName, 'time', options);
        filter.clear = function () { Filter.clearFilter(this); };
        filter.clearOption = function () { Filter.clearFilter(this); };
        filter.setOptionByValue = function (optionValue) {
            if (optionValue && optionValue.filterBy && optionValue.selectedRadio && optionValue.selectedRadio !== 'CUSTOM_RANGE') {
                let displayArray = [], valuesArray = [];
                filter.selectedRadio = optionValue.selectedRadio;
                valuesArray.push({ value: Date.now() - filter.selectedRadio, option: '#AFR#' });
                valuesArray.push({ value: Date.now(), option: '#BFR#' });
                displayArray.push(filter.radioOptions.filter((val) => val.value === filter.selectedRadio)[0].name);
                filter.dateAfter = null;
                filter.dateBefore = null;
                filter.displayFilterBy = displayArray.length > 1 ? [displayArray.join(' - ')] : displayArray; filter.filterBy = valuesArray;
                return;
            }
            let displayArray = [], valuesArray = [],
                isOptionObject = optionValue && optionValue.filterBy,
                tempParsedValue = {};
            if (isOptionObject) {
                optionValue.filterBy.forEach(i => {
                    if (i['option'].indexOf('AFR') !== -1) tempParsedValue.AFR = i.value;
                    else if (i['option'].indexOf('BFR') !== -1) tempParsedValue.BFR = i.value;
                })
            }
            let parsedValue = !isOptionObject ? JSON.parse(optionValue) : tempParsedValue;
            if (parsedValue) {
                for (let option in parsedValue) {
                    let formatedDate, displayDate;
                    if (!filter.datetimeLocaleFormat || !filter.datetimeLocaleFormat.locale || !filter.datetimeLocaleFormat.format || !filter.datetimeLocaleFormat.timezone) {
                        formatedDate = new Date(parsedValue[option]);
                        let month = (formatedDate.getMonth() + 1),
                            day = formatedDate.getDate(),
                            year = formatedDate.getFullYear(),
                            hours = formatedDate.getHours(),
                            minutes = formatedDate.getMinutes();
                        if (month < 10) month = '0' + month.toString();
                        if (day < 10) day = '0' + day.toString();
                        if (year < 10) year = '0' + year.toString();
                        if (hours < 10) hours = '0' + hours.toString();
                        if (minutes < 10) minutes = '0' + minutes.toString();
                        displayDate = `${month}/${day}/${year} ${hours}:${minutes}`;
                    } else {
                        formatedDate = Filter.converMilisecToDate(parsedValue[option], filter.datetimeLocaleFormat.locale, filter.datetimeLocaleFormat.format, filter.datetimeLocaleFormat.timezone);
                        displayDate = formatedDate;
                    }
                    displayArray.push(displayDate);
                    valuesArray.push({ value: parsedValue[option], option: `#${option}#` });
                    if (option === 'AFR') {
                        filter.dateAfter = formatedDate;
                        filter.dateAfterMilisec = parsedValue[option];
                    }
                    else {
                        filter.dateBefore = formatedDate;
                        filter.dateBeforeMilisec = parsedValue[option];
                    }
                }
            }
            filter.selectedRadio = 'CUSTOM_RANGE';
            filter.displayFilterBy = displayArray.length > 1 ? [displayArray.join(' - ')] : displayArray;
            filter.filterBy = valuesArray;
        };
        filter.setFilterByOptions = function () { Filter.internalFilterBySet(this); };
        filter.reset = function () { Filter.resetFilter(this, element); };
        return filter;
    }

    static getSelectFilter(name, key, options, cssCLassName, hasSearchBox) {
        let filter = Filter.initFilter(name, key, cssCLassName, 'select', options);
        filter.clear = function () { Filter.clearFilter(this); };
        filter.clearOption = function (optionLabel) { Filter.clearFilterOption(this, optionLabel); };
        filter.setOptionByValue = function (optionValue) { Filter.setFilterOptionByValue(this, optionValue); };
        filter.setFilterByOptions = function () { Filter.internalFilterBySet(this); };
        filter.reset = function () { Filter.resetFilter(this); };
        filter.hasSearchBox = hasSearchBox;
        return filter;
    }

    static getCheckboxFilter(name, key, options, cssCLassName) {
        let filter = Filter.initFilter(name, key, cssCLassName, 'checkbox', options);
        filter.clear = function () { Filter.clearFilter(this); };
        filter.clearOption = function (optionLabel) { Filter.clearFilterOption(this, optionLabel); };
        filter.setOptionByValue = function (optionValue) { Filter.setFilterOptionByValue(this, optionValue); };
        filter.setFilterByOptions = function () { Filter.internalFilterBySet(this); };
        filter.reset = function () { Filter.resetFilter(this); };
        return filter;
    }

    static getHiddenFilter(name, key, cssCLassName, findByUuid, additionalSearch) {
        let filter = Filter.initFilter(name, key, cssCLassName, '', null, findByUuid, additionalSearch);
        filter.clear = function () { Filter.clearFilter(this); };
        filter.clearOption = function () { Filter.clearFilter(this); };
        filter.setOptionByValue = function (optionValue) {
            this.search = optionValue;
            this.filterBy = this.search;
            this.filterByEncode = encodeURIComponent(this.search);
            this.displayFilterBy = [this.search];
        };
        filter.setFilterByOptions = function () { Filter.internalFilterBySet(this); };
        filter.reset = function () { Filter.resetFilter(this); };
        return filter;
    }

    static initFilter(name, key, cssCLassName, type, options, findByUuid, additionalSearch) {
        let filter = new Filter();
        filter.type = type;
        filter.name = name;
        filter.filterKey = key;
        filter.findByUuid = findByUuid;
        filter.additionalSearch = additionalSearch;
        filter.color = cssCLassName;
        if (type === 'checkbox') {
            filter.options = options;
            filter.optionsModel = {};
        }
        if (type === 'select') {
            filter.options = options;
            filter.selectedOptions = [];
        }
        if (type === 'time') {
            filter.radioOptions = options;
            filter.dateAfter = null;
            filter.dateBefore = null;
            filter.selectedRadio = null;
        }
        return filter;
    }

    static clearFilter(filter) {
        if (!filter) return;
        delete filter.filterBy;
        delete filter.filterByEncode;
        delete filter.displayFilterBy;
        if (filter.type === 'search') {
            filter.search = '';
            filter.jobUuids = [];
            return;
        }
        if (filter.type === 'checkbox') {
            filter.optionsModel = {};
            return;
        }
        if (filter.type === 'select') {
            filter.selectedOptions = [];
            filter.options.forEach(item => delete item.selected);
        }
        if (filter.type === 'time') {
            filter.selectedRadio = null;
            filter.dateAfter = null;
            filter.dateAfterMilisec = null;
            filter.dateBefore = null;
            filter.dateBeforeMilisec = null;
        }
    }

    static clearFilterOption(filter, optionLabel) {
        if (!filter) return;
        let optionObject = filter.options.filter(option => option[option.group && option.groupFilterLabel ? 'groupFilterLabel' : 'label'] === optionLabel)[0];
        if (filter.type === 'checkbox') filter.optionsModel[optionObject.value] = false;
        if (filter.type === 'select') {
            filter.selectedOptions = filter.selectedOptions && filter.selectedOptions.length ? filter.selectedOptions.filter(item => item[item.group && item.groupFilterLabel ? 'groupFilterLabel' : 'label'] !== optionLabel) : undefined;
            filter.options.forEach(item => { if (item[item.group && item.groupFilterLabel ? 'groupFilterLabel' : 'label'] === optionLabel) delete item.selected; });
        }
        Filter.internalFilterBySet(filter);
    }

    static internalFilterBySet(filter) {
        if (filter.type === 'select') {
            const valuesArray = [];
            const valuesArrayEncode = [];
            const displayArray = [];
            if (filter.selectedOptions) {
                filter.selectedOptions.forEach((elem) => {
                    valuesArray.push(elem[elem.group && elem.groupFilterValue ? 'groupFilterValue' : 'value']);
                    valuesArrayEncode.push(encodeURIComponent(elem[elem.group && elem.groupFilterValue ? 'groupFilterValue' : 'value']));
                    displayArray.push(elem[elem.group && elem.groupFilterLabel ? 'groupFilterLabel' : 'label']);
                });
            }
            filter.filterBy = valuesArray.join('||');
            filter.filterByEncode = valuesArrayEncode.join('||');
            filter.displayFilterBy = displayArray;
        }
        else if (filter.type === 'search') {
            filter.filterBy = filter.search;
            filter.filterByEncode = encodeURIComponent(filter.search);
            filter.displayFilterBy = [filter.search];
        }
        else if (filter.type === 'checkbox') {
            const valuesArray = [];
            const valuesArrayEncode = [];
            const displayArray = [];
            Object.keys(filter.optionsModel).forEach((key) => {
                if (filter.optionsModel[key]) {
                    valuesArray.push(key);
                    valuesArrayEncode.push(encodeURIComponent(key));
                    displayArray.push(filter.options.filter(option => option.value === key)[0].label);
                }
            });
            filter.filterBy = valuesArray.join('||');
            filter.filterByEncode = valuesArrayEncode.join('||');
            filter.displayFilterBy = displayArray;
        } else if (filter.type === 'time') {
            let displayArray = [], valuesArray = [];
            if (!filter.selectedRadio) return;
            if (filter.selectedRadio === 'CUSTOM_RANGE') {
                if (filter.dateAfter) {
                    valuesArray.push({ value: filter.dateAfterMilisec, option: '#AFR#' });
                    displayArray.push(filter.dateAfter);
                }
                if (filter.dateBefore) {
                    valuesArray.push({ value: filter.dateBeforeMilisec, option: '#BFR#' });
                    displayArray.push(filter.dateBefore);
                }
            } else {
                valuesArray.push({ value: Date.now() - filter.selectedRadio, option: '#AFR#' });
                valuesArray.push({ value: Date.now(), option: '#BFR#' });
                displayArray.push(filter.radioOptions.filter((val) => val.value === filter.selectedRadio)[0].name);
                filter.dateAfter = null;
                filter.dateBefore = null;
            }
            filter.displayFilterBy = displayArray.length > 1 ? [displayArray.join(' - ')] : displayArray;
            filter.filterBy = valuesArray;
        }
    }

    static setFilterOptionByValue(filter, optionValue) {
        let selectedItem = filter.options.filter(item => item[item.group && item.groupFilterValue ? 'groupFilterValue' : 'value'] === optionValue)[0];
        let optionValueList = [];
        if (!selectedItem) {
            filter.options.forEach(item => {
                let prop = item.group && item.groupFilterValue ? 'groupFilterValue' : 'value';
                if (optionValue.indexOf(item[prop]) !== -1) optionValueList.push(item[prop]);
            });
        }

        if (optionValueList && optionValueList.length) {
            optionValueList.forEach(value => {
                let selected = filter.options.filter(item => item[item.group && item.groupFilterValue ? 'groupFilterValue' : 'value'] === value)[0];
                Filter.setFilterOptionByValueInner(filter, value, selected);
            });
        } else {
            Filter.setFilterOptionByValueInner(filter, optionValue, selectedItem);
        }
    }

    static setFilterOptionByValueInner(filter, optionValue, selectedItem) {
        if (filter.type === 'checkbox') {
            if (filter.optionsModel[optionValue]) return;
            else filter.optionsModel[optionValue] = true;
        }
        if (filter.filterBy) {
            if (filter.type === 'select') filter.selectedOptions.push(selectedItem);
            filter.filterBy += '||' + optionValue;
            filter.filterByEncode += '||' + optionValue;
            filter.displayFilterBy.push(selectedItem[selectedItem.group && selectedItem.groupFilterLabel ? 'groupFilterLabel' : 'label']);
        } else {
            if (filter.type === 'select') filter.selectedOptions = [selectedItem];
            filter.filterBy = optionValue;
            filter.filterByEncode = encodeURIComponent(optionValue);
            filter.displayFilterBy = [selectedItem[selectedItem.group && selectedItem.groupFilterLabel ? 'groupFilterLabel' : 'label']];
        }
    }

    static resetFilter(filter) {
        if (!filter) return;
        if (filter.type === 'search') {
            filter.search = filter.filterBy;
            return;
        }
        if (filter.type === 'select') {
            if (!filter.displayFilterBy || !filter.displayFilterBy.length) filter.selectedOptions = [];
            else filter.selectedOptions = filter.options.filter(option => filter.displayFilterBy.indexOf(option[option.group && option.groupFilterLabel ? 'groupFilterLabel' : 'label']) >= 0);
            return;
        }
        if (filter.type === 'checkbox') {
            if (!filter.filterBy) filter.optionsModel = {};
            else {
                let tempFilterByList = [],
                    tempFilterByEncodeList = filter.filterByEncode.split('||');
                tempFilterByEncodeList.forEach(item => tempFilterByList.push(decodeURIComponent(item)));
                let tempSelectedItem = filter.options.filter(option => tempFilterByList.indexOf(option.value) >= 0),
                    tempObj = {};
                tempSelectedItem.forEach(item => tempObj[item.value] = true);
                filter.optionsModel = tempObj;
            }
        }
        if (filter.type === 'time') {
            if (filter.selectedRadio && (!filter.displayFilterBy || !filter.displayFilterBy.length)) {
                filter.clear();
            }
        }
    }


    static converMilisecToDate(input, locale, format, timezone) {
        const date = moment.utc(input);
        if (new Date(input).getFullYear() >= 2020) {
            //custom handle of years after 2020, because moment don't calculate well summer time after 2020 year
            let date = new Date(input);
            return `${date.toLocaleDateString(locale).replace(/ /g, '')} ${date.toLocaleTimeString([locale], { hour: '2-digit', minute: '2-digit' })}`;
        } else {
            return date.locale(locale).tz(timezone).format(format);
        }
    }
}


module.exports = Filter;


// WEBPACK FOOTER //
// ./src/shared/ctxFiltersPanel/ctxFilterModel.js